import { AuthProvider } from './app/providers/AuthProvider';
import { StoreProvider } from './app/providers/StoreProvider';
import { ThemeProvider } from './app/providers/ThemeProvider';
import Router from './app/routes/Router';
import { TW_PRESET_CLASSES } from './utils/tailwind-preset';

function App() {
  // Assure que les classes Tailwind personnalisées sont incluses dans le bundle
  console.log('Classes Tailwind chargées:', TW_PRESET_CLASSES.length > 0);

  return (
    <StoreProvider>
      <AuthProvider>
        <ThemeProvider>
          <Router />
        </ThemeProvider>
      </AuthProvider>
    </StoreProvider>
  );
}

export default App;
